import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "passenger-details group" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "travel-details" }
const _hoisted_5 = { class: "button-group" }
const _hoisted_6 = { class: "button-group__submit" }
const _hoisted_7 = {
  key: 0,
  class: "error-messages"
}
const _hoisted_8 = { key: 0 }

import SvgIcon from "@/components/icons/SvgIcon.vue";
import useDialog from "@/composables/useDialog";
import { dateFormat } from "@/helpers/dateHelpers";
import { isValidDepartures, isValidPassengers } from "@/helpers/quickformHelpers";
import { Direction } from "@/models/Enums";
import { DialogType } from "@/models/symbols/Dialog";
import { usePassengerStore } from "@/store/passengerStore";
import { useQuickFormStore } from "@/store/quickFormStore";
import { useVehicleStore } from "@/store/vehicleStore";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { AxiosError } from "axios";
import { VBtn } from "v-ferry-components";
import { computed, onMounted, reactive } from "vue";
import useCreateRequest from "../composables/useCreateRequest";
import { MultiLegDepartureDetails, MultiLegState } from "../models/MultiLegForm";
import { DepartureRequest, DepartureResponse } from "../models/QuickformApi";
import { PassengerItem } from "../models/QuickformStates";
import Passengers from "./passengers/PassengersForm.vue";
import RouteAndDate from "./RouteAndDate.vue";
import VehicleForm from "./vehicle/VehicleForm.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiLegForm',
  setup(__props) {

const passengerStore = usePassengerStore();

const quickFormStore = useQuickFormStore();

const state = reactive<MultiLegState>({
    passengers: passengerStore.getPassengers(Direction.Outward) as PassengerItem[],
    departures: [] as MultiLegDepartureDetails[],
});

const rules = {
    passengers: {
        required: helpers.withMessage("Need to have at least one adult on each journey", () => {
            return isValidPassengers();
        }),
    },
    departures: {
        required: helpers.withMessage("Your dates have to be in order", () => {
            return isValidDepartures(state.departures);
        }),
        v: () => {
            return state.departures.every((departure) => {
                return departure.date && departure.route;
            });
        },
    },
};

const v$ = useVuelidate(rules, state);

const vehicleStore = useVehicleStore();

const departures = computed(() => quickFormStore.getDepartures);

onMounted(() => {
    if (departures.value.length) {
        for (let index = 0; index < departures.value.length; index++) {
            const departure = departures.value[index];
            addDeparture(departure.route, new Date(departure.date));
        }
    } else {
        addDeparture();
    }
});

const addDeparture = (route?: string, date?: Date) => {
    state.departures.push({ route: route ?? "", date: date ?? undefined });
};

const removeDeparture = () => {
    state.departures.splice(-1, 1);
};

const { create } = useCreateRequest();

const { displayDialog } = useDialog();

const submit = async () => {
    const isValid = await v$.value.$validate();

    if (!isValid) return;

    const vehiclesOutward = vehicleStore.getVehiclesOfRoute(Direction.Outward);
    const passengersOutward = passengerStore.getPassengersForApi(Direction.Outward);
    const request: DepartureRequest[] = [];

    state.departures.map((d) => {
        if (!d.date) return;
        request.push({
            date: dateFormat(d.date),
            route: d.route,
            resources: passengersOutward,
            vehicles: vehiclesOutward,
        });
    });

    create(request)
        .then((data) => {
            quickFormStore.setDepartures(request);
            window.location.href = "/book/departures";
        })
        .catch((err: AxiosError) => {
            const errResponse: DepartureResponse = err.response?.data as DepartureResponse;
            if (errResponse.error) {
                displayDialog({
                    title: errResponse.message ?? "Something went wrong",
                    message:
                        errResponse.bookitErrorCode == 12009
                            ? "Sorry - you cannot book more vehicles than the number of travellers."
                            : "Something unexpected happened, please try again",
                    confirmText: "I understand",
                    type: DialogType.danger,
                });
            } else {
                quickFormStore.setDepartures(request);
                window.location.href = "/book/departures";
            }
        });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(submit, ["prevent"]),
      class: "multi-leg-form"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("label", null, "Passenger", -1)),
          _createVNode(Passengers, {
            errorMessage: _unref(v$).passengers.$errors.map((e) => e.$message.toString())[0]
          }, null, 8, ["errorMessage"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("label", null, "Vehicle", -1)),
          _createVNode(VehicleForm)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).departures.$model, (item, index) => {
          return (_openBlock(), _createBlock(RouteAndDate, {
            modelValue: _unref(v$).departures.$model[index],
            "onUpdate:modelValue": ($event: any) => ((_unref(v$).departures.$model[index]) = $event),
            allDepartures: _unref(v$).departures.$model,
            key: index,
            index: index
          }, {
            default: _withCtx(() => [
              (_unref(v$).departures.$model.length > 1 && index == Object.keys(_unref(v$).departures.$model).length - 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: removeDeparture,
                    class: "travel-details__remove"
                  }, [
                    _createVNode(SvgIcon, {
                      class: "icon",
                      icon: "close"
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text" }, "Remove", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "allDepartures", "index"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (state.departures.length < 4)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (addDeparture())),
              class: "button-group__add"
            }, [
              _createVNode(SvgIcon, {
                class: "icon",
                icon: "plus"
              }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Add route", -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(VBtn), { type: "submit" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Book now")
            ])),
            _: 1,
            __: [5]
          })
        ])
      ])
    ], 32),
    (_unref(v$).$errors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Set(_unref(v$).$errors.map((e) => e.$message)), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "message"
            }, [
              item
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createVNode(SvgIcon, {
                      class: "icon",
                      icon: "error"
                    }),
                    _createTextVNode(" " + _toDisplayString(item), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})